import { render, staticRenderFns } from "./defaultSiteHeader.vue?vue&type=template&id=f5b22eae&scoped=true&"
import script from "./defaultSiteHeader.vue?vue&type=script&lang=js&"
export * from "./defaultSiteHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5b22eae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
